import { PageHeader, Popconfirm, Tag, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import { ButtonItem, TableItem, dineroDisabledMask, HeaderActions } from "../../../Components/Items";
import { CloseCircleOutlined, ArrowRightOutlined, ShoppingOutlined } from "@ant-design/icons";
import CancelarVenta from "../Ventas/CancelarVenta/CancelarVenta";

moment.locale("es");

class VentasConsignacion extends Component {
  state = {
    todasVentas: [],
    loading: false,
    modalCancelacion: false,
    modalCancelacionId: null,
    modalEnvios: false,
    modalEnviosId: null
  };
  componentDidMount() {
    this.consultarVentasConsignacion();
  }

  consultarVentasConsignacion() {
    this.setState({ loading: true });
    axios
      .post(
        "consignaciones/selectVentasConsignaciones",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.status === 404) {
        } else {
          this.setState({
            todasVentas: res.data.map((value) => {
              let numero = ''
              if (value.remision) {
                numero += (value.remisionSerie ? value.remisionSerie : 'R') + ' ' + value.remisionNumero
              }
              if (value.factura) {
                if (numero !== '') {
                  numero += ' '
                }
                numero += (value.facturaSerie ? value.facturaSerie : 'F') + ' ' + value.facturaNumero
              }
              return {
                ...value,
                fechaVenta: value.fechaFactura
                  ? value.fechaFactura
                  : value.fechaRemision,
                numero: numero,
                clienteNombre: value.cliente.persona ? value.cliente.razonSocial : (value.cliente.nombre + ' ' + value.cliente.apellidoPaterno + ' ' + value.cliente.apellidoMaterno),
                clienteRfc: value.cliente.rfc,
                cliente: (value.cliente.persona ? value.cliente.razonSocial : (value.cliente.nombre + ' ' + value.cliente.apellidoPaterno + ' ' + value.cliente.apellidoMaterno)) + " - " + value.cliente.rfc,
                accion: {
                  _id: value._id,
                  dataFactura: !!value.dataFactura,
                  estado: value.estado,
                  estadoCosteo: value.estadoCosteo,
                  servicios: value.servicios,
                  estadoPago: value.estadoPago,
                  facturaGlobal: value.facturaGlobal,
                  factura: value.factura,
                  contado: value.contado,
                  remision: value.remision,
                  cuentasXC: value.cuentasXC,
                  envios: value.envios,
                },
              };
            }),
          });
        }
      });
  }

  agregarVenta() {
    this.props.history.push("/panel/agregarVentaConsignacion");
  }
  facturaGlobal() {
    this.props.history.push("/panel/facturaGlobalConsignacion");
  }
  entregarInsumosVenta(id) {
    this.props.history.push("/panel/entregarInsumosVentaConsignacion", { id });
  }
  generarFacturaVenta(id) {
    this.props.history.push("/panel/generarFacturaVentaConsignacion", { id });
  }
  cancelarVenta(value) {
    this.setState({ modalCancelacion: true, modalCancelacionId: value });
  }
  cerrarCancelarVenta() {
    this.setState({
      modalCancelacion: false,
      modalCancelacionId: null,
    });
    this.consultarVentas();
  }
  enviosVenta(value) {
    this.setState({ modalEnvios: true, modalEnviosId: value });
  }
  cerrarEnviosVenta() {
    this.setState({
      modalEnvios: false,
      modalEnviosId: null,
    });
    this.consultarVentas();
  }
  render() {
    const isMobile = window.innerWidth <= 1000;
    const columns = [
      {
        title: "F/R",
        dataIndex: "numero",
        key: "numero",
        buscar: 'numero',
        width: "7%",
      },
      {
        title: "Proyecto",
        dataIndex: "proyecto",
        responsive: ["md"],
        key: "proyecto",
        sorter: (a, b) => {
          if (a.proyecto.nombre < b.proyecto.nombre) {
            return -1;
          }
          if (a.proyecto.nombre > b.proyecto.nombre) {
            return 1;
          }
          return 0;
        },
        render: (value) => value.nombre,
        width: "16%",
        ellipsis: true,
      },
     {
        title: "Cliente",
        dataIndex: "clienteNombre",
        key: "clienteNombre",
        buscar: "cliente",
        sorter: true,
        render: (_, record) => (
            <div>
                <div style={{ fontSize: "12px", fontWeight: "bold" }}>
                {record.clienteNombre}
                </div>
            </div>
        ),
        width: "16%",
        ellipsis: true,
        },
        {
        title: "RFC",
        dataIndex: "clienteRfc",
        key: "clienteRfc",
        render: (value) => (
            <div style={{ fontSize: "12px" }}>
                {value}
            </div>
        ),
        width: "12%",
        ellipsis: true,
      },
      {
        title: "Fecha",
        dataIndex: "fechaVenta",
        responsive: ["md"],
        key: "fechaVenta",
        sorter: (a, b) => {
          if (moment(a.fechaVenta) < moment(b.fechaVenta)) {
            return -1;
          }
          if (moment(a.fechaVenta) > moment(b.fechaVenta)) {
            return 1;
          }
          return 0;
        },
        render: (value) => moment(value).locale("es").format("ll"),
        wdith: "16%",
        ellipsis: true,
        align: "center",
      },
      {
        title: "Subtotal / Total",
        dataIndex: "subtotal",
        key: "subtotal",
        sorter: (a, b) => {
          if (a.subtotal < b.subtotal) {
            return -1;
          }
          if (a.subtotal > b.subtotal) {
            return 1;
          }
          return 0;
        },
        render: (_, record) => (
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: "12px", color: "#666", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
              <span>{dineroDisabledMask(record.subtotal)}</span>
              {record.moneda.abreviacion && <span style={{ fontSize: "12px", color: "#666" }}>{record.moneda.abreviacion}</span>}
            </div>
            <div style={{ fontSize: "12px", fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
              <span>{dineroDisabledMask(record.total)}</span>
              {record.moneda.abreviacion && <span style={{ fontSize: "12px", color: "#666" }}>{record.moneda.abreviacion}</span>}
            </div>
          </div>
        ),
        buscar: "subtotal",
        width: "13%",
        ellipsis: true,
        align: "right",
      },
      {
        title: "Total",
        dataIndex: "total",
        key: "total",
        sorter: (a, b) => {
          if (a.total < b.total) {
            return -1;
          }
          if (a.total > b.total) {
            return 1;
          }
          return 0;
        },
        buscar: "total",
        responsive: [],
        width: 0,
      },
      {
        title: "Estado",
        dataIndex: "estado",
        responsive: ["md"],
        key: "estado",
        render: (value) => {
          if (value === 0) {
            return <Tag color="red" className="square-tag">Cancelada</Tag>;
          }
          if (value === 1) {
            return <Tag color="blue" className="square-tag">Sin entregar</Tag>;
          }
          if (value === 2) {
            return <Tag color="orange" className="square-tag">Entregado parcialmente</Tag>;
          }
          if (value === 3) {
            return <Tag color="green" className="square-tag">Entregado</Tag>;
          }
        },
        width: "13%",
        ellipsis: true,
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        width: "15%",
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (value, index) => {
          if (value.estado === 0) return null;

          let buttons = [];

          const puedeEntregar = (value.estado === 1 || value.estado === 2) && this.props.permisoEntregarInsumosVenta;
          buttons.push(
            <Tooltip title={puedeEntregar ? "Entregar Insumos" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                key={`entregar-${index}`}
                type="default"
                size="small"
                blanco
                icon={<ShoppingOutlined />}
                onClick={() => puedeEntregar && this.entregarInsumosVenta(value._id)}
                disabled={!puedeEntregar}
              >
              </ButtonItem>
            </Tooltip>
          );

          const puedeFacturar = value.remision && !value.facturaGlobal && !value.factura && this.props.certificada && (value.estadoPago === 0 || value.contado === 1);
          buttons.push(
            <Tooltip title={puedeFacturar ? "Facturar" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                key={`facturar-${index}`}
                type="default"
                size="small"
                lima
                icon={<ArrowRightOutlined />}
                onClick={() => puedeFacturar && this.generarFacturaVenta(value._id)}
                disabled={!puedeFacturar}
              >
              </ButtonItem>
            </Tooltip>
          );

          const puedeCancelar = value.estado !== 0 && (value.estadoPago === 0 || value.contado === 1) && (!value.cuentasXC || value.estadoPago === 0) && this.props.permisoDarBajaVenta && (value.envios?.length <= 0 || !value.envios || value.estado === 1);
          buttons.push(
            <Popconfirm
              key={`cancelar-${index}`}
              title={
                this.props.certificada && value.factura
                  ? "Seguro que quieres cancelar esta venta, tambien se cancelara la factura"
                  : "Seguro que quieres cancelar esta venta"
              }
              onConfirm={() => this.cancelarVenta(value._id)}
              okText="Si"
              cancelText="No"
              disabled={!puedeCancelar}
            >
              <Tooltip title={puedeCancelar ? "Cancelar" : "No se puede cancelar"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  type="default"
                  size="small"
                  rojo
                  icon={<CloseCircleOutlined />}
                  disabled={!puedeCancelar}
                >
                </ButtonItem>
              </Tooltip>
            </Popconfirm>
          );

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];
    return (
      <>
        <PageHeader
          title="Ventas Consignación"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <HeaderActions>
                {this.props.certificada && this.props.permisoFacturaGlobalVenta && !isMobile && (
                  <ButtonItem
                    key="facturaGlobal"
                    type="primary"
                    cuero
                    onClick={this.facturaGlobal.bind(this)}
                  >
                    Factura Global
                  </ButtonItem>
                )}
              </HeaderActions>

              {this.props.permisoAgregarVenta &&
                <ButtonItem
                  type="primary"
                  key="agregarVenta"
                  olivo
                  onClick={this.agregarVenta.bind(this)}
                  style={{ fontSize: '14px', padding: '6.4px 15px', height: '32px' }}
                >
                  Agregar Venta
                </ButtonItem>
              }
            </div>
          }
        />
        <TableItem
          onRow={(record, rowIndex) => {
            return {
              onDoubleClick: (event) => {
                this.props.history.push("/panel/verVentaConsignacion", { id: record._id });
              },
            };
          }}
          loading={this.state.loading}
          size="small"
          dataSource={this.state.todasVentas}
          columns={columns}
          pagination={false}
        />
        <CancelarVenta
          visible={this.state.modalCancelacion}
          id={this.state.modalCancelacionId}
          cerrarCancelarVenta={this.cerrarCancelarVenta.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    certificada: state.empresa.certificada,
    envios: state.empresa.envios,
    permisoAgregarVenta:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "67509415798d4e004368724a"
      )?.activado,
    permisoCancelarVenta:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6472d37f4b2da7c85c1a8cff"
      )?.activado,
    permisoEntregarInsumosVenta:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615ccbaff30e81b54183cf71"
      )?.activado,
      permisoFacturaGlobalVenta:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "67509441798d4e004368724b"
      )?.activado,
      permisoDarBajaVenta:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6750945d798d4e004368724c"
      )?.activado,
  };
};

export default connect(mapStateToProps)(VentasConsignacion);
